import { useCallback } from 'react';

import {
  tikTokAdvancedMatching,
  tikTokEvent,
  useAnalytics,
} from '@features/Analytics';
import { twitterEvent } from '@features/Analytics/services/twitter-pixel';
import { createAppLovinUserData } from '@features/Analytics/utils';
import { useFeature } from '@features/FeatureToggle';

export const useTrackEmailSignup = () => {
  const {
    trackFacebookEvent,
    trackGoogleEvent,
    trackPinterestEvent,
    trackAppLovin,
  } = useAnalytics();
  const fbPixelSept2025Feature = useFeature('fbPixelSept2025Feature');

  const trackEmailSignup = useCallback(
    (email: string, onSuccess?: () => void) => {
      trackGoogleEvent({
        eventName: 'onboarding_email_tapped',
        options: {
          email,
        },
      });
      trackFacebookEvent({
        eventName: fbPixelSept2025Feature ? 'Lead' : 'CompleteRegistration',
        options: {
          email,
        },
      });
      trackPinterestEvent({ eventName: 'Signup' });
      trackAppLovin({
        eventName: 'sign_up',
        options: {
          method: 'email',
          user_data: createAppLovinUserData({ userEmail: email }),
        },
      });

      //TODO: change to valid twitter event
      twitterEvent('example1', { email_address: email });
      tikTokAdvancedMatching(email);
      tikTokEvent('CompleteRegistration');

      onSuccess?.();
    },
    [
      fbPixelSept2025Feature,
      trackFacebookEvent,
      trackGoogleEvent,
      trackPinterestEvent,
      trackAppLovin,
    ],
  );

  return {
    trackEmailSignup,
  };
};
